import {
  faBasketShopping,
  faCalendarDay,
  faCubesStacked,
  faFlaskVial,
  faGlobe,
  faPuzzlePiece,
  faQuestion,
  faShopLock,
  faSquareArrowUpRight,
  faStore,
} from '@fortawesome/free-solid-svg-icons';
import { SourceType } from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import { type MaybeRef } from 'vue';
import { useBadgeInfoObject } from '../style/useBadgeInfoObject';
import type { DisplayBadgeType } from '../style/useDisplayBadgeClass';

export const useSourceTypeInfo = (
  colorType: MaybeRef<DisplayBadgeType> = 'badge',
  source?: MaybeRef<SourceType | 'global'>,
) => {
  const { badgeInfo, getBadgeClass, getBadgeColor, getBadgeIcon, getBadgeTitle, getBadgeInfo } =
    useBadgeInfoObject<SourceType | 'global'>(
      {
        i18nPrefix: 'source.type',
        colorMap: {
          [SourceType.CUSTOM]: 'secondary',
          [SourceType.IN_STORE]: 'success',
          [SourceType.WEBSHOP]: 'primary',
          [SourceType.EVENT_BOOTH]: 'error',
          [SourceType.EXTERNAL_PARTNER]: 'secondary',
          [SourceType.EXTERNAL_STORE]: 'success',
          [SourceType.SANDBOX]: 'warning',
          global: 'info',
        },
        iconMap: {
          [SourceType.CUSTOM]: faCubesStacked,
          [SourceType.IN_STORE]: faStore,
          [SourceType.WEBSHOP]: faBasketShopping,
          [SourceType.EVENT_BOOTH]: faCalendarDay,
          [SourceType.EXTERNAL_PARTNER]: faPuzzlePiece,
          [SourceType.EXTERNAL_STORE]: faShopLock,
          [SourceType.SANDBOX]: faFlaskVial,
          global: faGlobe,
        },
        defaultColor: 'error',
        defaultIcon: faQuestion,
      },
      colorType,
      source,
    );

  return {
    sourceTypeInfo: badgeInfo,
    getSourceTypeTitle: getBadgeTitle,
    getSourceTypeClass: getBadgeClass,
    getSourceTypeColor: getBadgeColor,
    getSourceTypeIcon: getBadgeIcon,
    getSourceTypeInfo: getBadgeInfo,
  };
};
